module.exports = __webpack_public_path__ + "img/shoot-2022.c173c177.png";